<template>
  <div id="IndexSICSEN_div">

    <menusuperior titulo="SICSEN" subtitulo="Sistema de Control de Sentencias"></menusuperior>
    <menuizquierda></menuizquierda>

    <div v-if="$route.fullPath == RUTA_RAIZ_SISTEMA">      
      <div class="content-area">
        <transition name="fade" mode="out-in">
          <router-view :key="$route.fullPath"></router-view>
        </transition>
        <div id="bienvenida" class="d-flex justify-content-center align-items-center" v-if="$route.name == 'SICSEN'">
          <div id="secciondebienvenida" class="d-flex flex-wrap align-items-center justify-content-center">
            <figure class="text-center" style="margin-top: 10em;">
              <img src="../../../assets/paginaoficial/Logotipo_Positivo_Vertical.png" alt="Logo de Poder Judicial del Estado de Aguascalientes" />
            </figure>          
          </div>
        </div>
      </div>
    </div>

    <div v-show="$route.fullPath != RUTA_RAIZ_SISTEMA" class="content-area">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>  

  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/Comunes/MenuIzquierdaDeLosSistemas.vue'
  import bienvenidaSistemas from '@/components/Tablero/BienvenidaSistemas.vue';
  import comun from '@/../static/js/comun'

  export default {
    name: 'Plantilla',
    components: {
      menusuperior: menusuperior,
      menuizquierda: menuizquierda,
      bienvenidaSistemas: bienvenidaSistemas
    },
    data() {
      return {
        RUTA_RAIZ_SISTEMA: '/SICSEN'
      }
    }
  }
</script>
<style scoped>
#secciondebienvenida {
    width: 40vw;
    height: 600px;
    align-content: center;
  }

  h2 {
    margin-top: 3vh;
    text-align: center;
  }

  h4 {
    margin-top: 1vh;
  }

  @media (max-width: 991px) {
    h2 {
      font-size: .9rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SICSEN/Comun/Plantilla.vue